import { MenuItem } from '@app/core/models/menu.model';

/**
 * UserMenuItems
 * @type {{label: string; link: string; order: number}[]}
 */
export const UserMenuItems: MenuItem[] = [
  {
    label: 'Log out',
    link: '/auth/logout',
    order: 1,
  },
];
/**
 * AppMenuItems
 * @type {{label: string; link: string; order: number}[]}
 */
export const AppMenuItems: MenuItem[] = [
  {
    label: 'Announcements',
    link: '/announcements',
    order: 1,
  },
  {
    label: 'Glossary',
    link: '/dashboard',
    order: 2,
  },
  {
    label: 'My Orders',
    link: '/orders',
    order: 3,
  }
];
export const AppMenuItems2: MenuItem[] = [
  {
    label: 'Announcements',
    link: '/announcements',
    order: 1,
  },
  {
    label: 'Glossary',
    link: '/dashboard',
    order: 2,
  },
  {
    label: 'My Orders',
    link: '/orders',
    order: 3,
  }
];
export const AppMenuItems3: MenuItem[] = [
  {
    label: 'Announcements',
    link: '/announcements',
    order: 1,
  },
  {
    label: 'Glossary',
    link: '/dashboard',
    order: 2,
  },
  {
    label: 'My Orders',
    link: '/orders',
    order: 3,
  },
  {
    label: 'Essilor Admin Dashboard',
    link: '/essiloradmin/dashboard',
    order: 4,
  },
];
